/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.sobject', [])
  /**
   * Service used to access all calls to the sobject rest service.
   */
  .service('httpSObject', function ($http) {
    /**
     * Get the data array for versions of an object.
     *
     * @returns {Promise} A promise that resolves into the array of versions.
     */
    var getVersions = function (objectId, objectType) {
      return $http({
        method: 'GET',
        url: 'api/sobject/versions',
        params: {
          sfObjectId: objectId,
          sObjectType: objectType
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the data array for diffs of an object.
     *
     * @returns {Promise} A promise that resolves into a DiffInfo object.
     */
    var getDiff = function (recordId, recordBatchId) {
      return $http({
        method: 'GET',
        url: 'api/sobject/diff',
        params: {
          recordId: recordId,
          recordBatchId
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Returns the list of Salesforce object types.
     *
     * @returns {Promise<object[]>} A promise of the list.
     */
    function getTypes() {
      return $http({
        method: 'GET',
        url: 'api/sobject/types'
      }).then((res) => res.data);
    }

    return {
      getDiff: getDiff,
      getTypes: getTypes,
      getVersions: getVersions
    };
  });
